import { Node_Type } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PAGE_SIZE = 25;
const WAIT_INTERVAL = 300;
const SEARCH_TYPE = "gifs";
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  },
  configViewer: {
    sizes: { desktop: "original", mobile: "original" }
    // original or downsizedSmall are supported
  }
});
const MOBILE_FULL_SCREEN_CUSTOM_STYLE = Object.freeze({
  overlay: {
    backgroundColor: "transparent"
  },
  content: {
    top: 0,
    left: 0,
    overflow: "hidden",
    paddingRight: "6px"
  }
});
const commonDesktopModalStyles = {
  width: "320px",
  boxSizing: "border-box",
  height: "364px",
  overflow: "visible",
  paddingRight: "12px",
  paddingLeft: "12px",
  display: "block",
  position: "absolute",
  zIndex: 6,
  paddingTop: "12px"
};
const DESKTOP_FLY_OUT_MODAL_STYLES = Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 5
  },
  content: __spreadProps(__spreadValues({}, commonDesktopModalStyles), {
    border: "solid 1px rgba(51, 51, 51, 0.1)",
    boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))",
    borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)"
  })
});
const EXTERNAL_POPUP_STYLES = Object.freeze({
  content: commonDesktopModalStyles
});
const gifModals = {
  insert: `${Node_Type.GIF}.insert`,
  replace: `${Node_Type.GIF}.replace`
};
const GIF_BUTTONS = {
  alignment: `${Node_Type.GIF}.alignment`,
  size: `${Node_Type.GIF}.size`
};
const imagePlaceholder = (
  // eslint-disable-next-line max-len
  "data:image/webp;base64, UklGRtgAAABXRUJQVlA4IMwAAABQFgCdASomASYBPhkMhUIhBAUABABhLS3cLuwjaAE9gHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99qwAAP7/9viAAAAAAAAAAAAAAAA="
);

export { DEFAULTS, DESKTOP_FLY_OUT_MODAL_STYLES, EXTERNAL_POPUP_STYLES, GIF_BUTTONS, MOBILE_FULL_SCREEN_CUSTOM_STYLE, PAGE_SIZE, SEARCH_TYPE, WAIT_INTERVAL, gifModals, imagePlaceholder };
//# sourceMappingURL=constants.js.map
